module.exports = __webpack_public_path__ + "static/media/uranus-1.85d013fe.jpg";